import type { UnitSystem } from '../preferences'

export interface Coordinate {
  latitude: number
  longitude: number
}

const earthRadiusKilometers = 6371.0088

export function distanceBetweenCoordinates(from: Coordinate, to: Coordinate): number {
  const radians = (degrees: number) => degrees * Math.PI / 180
  const latitudeDelta = radians(to.latitude - from.latitude)
  const longitudeDelta = radians(to.longitude - from.longitude)
  const fromLatitude = radians(from.latitude)
  const toLatitude = radians(to.latitude)
  const haversine = Math.sin(latitudeDelta / 2) ** 2
    + Math.cos(fromLatitude) * Math.cos(toLatitude) * Math.sin(longitudeDelta / 2) ** 2
  return earthRadiusKilometers * 2 * Math.atan2(Math.sqrt(haversine), Math.sqrt(1 - haversine))
}

export function formatViewerDistance(kilometers: number, unitSystem: UnitSystem): string {
  if (unitSystem === 'us') {
    const miles = kilometers * 0.621371
    if (miles < 0.1) return `${Math.round(kilometers * 3280.84)} ft`
    return `${miles.toLocaleString('en-GB', { maximumFractionDigits: 1 })} mi`
  }
  if (kilometers < 1) return `${Math.round(kilometers * 1000)} m`
  return `${kilometers.toLocaleString('en-GB', { maximumFractionDigits: 1 })} km`
}

export function googleMapsDirectionsUrl(target: Coordinate): string {
  const url = new URL('https://www.google.com/maps/dir/')
  url.searchParams.set('api', '1')
  url.searchParams.set('dir_action', 'navigate')
  url.searchParams.set('destination', `${target.latitude},${target.longitude}`)
  return url.toString()
}
